import React, { useMemo, useEffect } from 'react';
import { FormContainer, SectionTitle, SectionSubtitle, GridContainer, FullWidthGrid } from './Styles';
import FormField from './FormField';
import SelectField from './SelectField';
import { generateIntakeOptions, getCurrentSession } from '../../utils/helper';


export default function AcademicDetailsStep({ errors, touched, values, setFieldValue }) {
    const handleSelectChange = (fieldName) => (event) => {
        setFieldValue(fieldName, event.target.value);
    };

    // Generate intake options using utility function
    const intakeOptions = useMemo(() => generateIntakeOptions(7, 7), []);

    // Set default value to current session
    useEffect(() => {
        if (!values.intakeDate) {
            const currentSession = getCurrentSession(7);
            setFieldValue('intakeDate', currentSession);
        }
    }, [values.intakeDate, setFieldValue]);
    useEffect(() => {
        if (!values.occupation) {
            setFieldValue('occupation', 1);
        }
    }, [values.occupation, setFieldValue]);
    const academicStandingOptions = [
        { value: 1, label: '1st Year' },
        { value: 2, label: '2nd Year' },
        { value: 3, label: '3rd Year' },
        { value: 4, label: '4th Year' },
    ];

    const courseOptions = [
        { value: 'UG', label: 'UG' },
        { value: 'PG', label: 'PG' },
        { value: 'Diploma', label: 'Diploma' },
        { value: 'PhD', label: 'PhD' },
    ];
    const occupationOptions = [
        { value: 1, label: 'Student' },
        { value: 2, label: 'Salaried' },
    ];

    const isSalaried = values.occupation === 2;
    return (
        <FormContainer>
            <SectionTitle>Institution Details</SectionTitle>
            <SectionSubtitle>
                Tell us about your institution background and current enrollment.
            </SectionSubtitle>

            <GridContainer>
                <FormField
                    name="studentId"
                    label="Student / Employee ID"
                    type="text"
                    placeholder="Enter student/employee ID"
                    required
                    error={errors.studentId}
                    touched={touched.studentId}
                />

                <FormField
                    name="instituteName"
                    label="Institute / College Name"
                    type="text"
                    placeholder="Enter your institute or college name"
                    required
                    error={errors.instituteName}
                    touched={touched.instituteName}
                />

                <SelectField
                    name="occupation"
                    label="Occupation"
                    value={values.occupation}
                    onChange={handleSelectChange('occupation')}
                    options={occupationOptions}
                    placeholder="Select Occupation"
                    required
                    error={errors.occupation}
                    touched={touched.occupation}
                />

                {/* Academic Standing - Only show if NOT Salaried */}
                {!isSalaried && (
                    <SelectField
                        name="academicStanding"
                        label="Academic Standing"
                        value={values.academicStanding}
                        onChange={handleSelectChange('academicStanding')}
                        options={academicStandingOptions}
                        placeholder="Select Year"
                        required
                        error={errors.academicStanding}
                        touched={touched.academicStanding}
                    />
                )}

                {!isSalaried && (
                    <SelectField
                        name="course"
                        label="Course"
                        value={values.course}
                        onChange={handleSelectChange('course')}
                        options={courseOptions}
                        placeholder="Select Course"
                        required
                        error={errors.course}
                        touched={touched.course}
                    />
                )}
                <FormField
                    name="stream"
                    label="Stream / Department"
                    type="text"
                    placeholder="Enter your stream/department"
                    required
                    error={errors.stream}
                    touched={touched.stream}
                />
                <FullWidthGrid>
                    <SelectField
                        name="intakeDate"
                        label="Intake Date"
                        value={values.intakeDate}
                        onChange={handleSelectChange('intakeDate')}
                        options={intakeOptions}
                        placeholder="Select Intake"
                        required
                        error={errors.intakeDate}
                        touched={touched.intakeDate}
                    />
                </FullWidthGrid>
            </GridContainer>
        </FormContainer>
    );
}